import styled from "styled-components";

export const NavWrappper = styled.nav`
  display: flex;
  flex-direction: column;

  &#menuCima {
    display: none;
  }

  @media only screen and (max-width: 1200px) {
    &#menuCima {
      display: flex;
    }

    &#menuBaixo {
      display: none;
    }
  }
`;

export const TituloMenu = styled.h3`
  color: ${({ theme }) => theme.colors.primaria};
  font-size: 16px;
  font-weight: bold;
  width: fit-content;
  cursor: pointer;

  @media only screen and (max-width: 1200px) {
    padding: 5px;
    border: 1px solid ${({ theme }) => theme.colors.primaria};
    border-radius: 5px;
  }
`;

export const LinksWrapper = styled.nav`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  * {
    overflow: hidden;
  }

  .ativo {
    border-left: solid 5px ${({ theme }) => theme.colors.secundaria};
    background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
    color: ${({ theme }) => theme.colors.primaria};

    ul {
      height: 100%;
    }
  }

  li {
    font-size: 13px;
    border-left: solid 2px ${({ theme }) => theme.colors.secundaria};
    padding: 8px 12px;
    font-weight: bold;
    cursor: pointer;
    transition: color 0.5s, border 0.5s;

    &:hover {
      border-left: solid 5px ${({ theme }) => theme.colors.secundaria};
      background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
      color: ${({ theme }) => theme.colors.primaria};

      ul {
        height: 100%;
      }
    }

    ul {
      height: 0;
      transition: height 0.5s;

      li {
        height: fit-content;
        font-weight: normal;
        &:hover {
          height: fit-content;
          font-weight: bolder;
        }
      }
    }
  }

  @media only screen and (max-width: 1200px) {
    grid-template-columns: none;
    display: flex;
    flex-direction: column;
    justify-content: start;
    margin-bottom: 15px;
    overflow: hidden;
    transition: max-height 0.6s;
    max-height: 0;

    &.mostrar {
      max-height: 303px;
    }
  }
`;
